import {FlowStateController} from "@nolimit/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimit/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {FreeSpinNoWinPause} from "../../presentations/freespin/FreeSpinNoWinPause";
import {FreespinOutroPresentation} from "../../presentations/freespin/FreespinOutroPresentation";
import {WinCapPresentation} from "../../presentations/WinCapPresentation";
import {SideTrainUpgrade} from "../../presentations/freespin/SideTrainUpgrade";
import {ChestCollectPresentation} from "../../presentations/freespin/ChestCollectPresentation";
import {FITH2BigWinPresentation} from "../../presentations/FITH2BigWinPresentation";

export class FITH2FSWinPresentation implements FlowStatePresentation {

    private _presentations: SimplePresentation[];

    constructor() {
            this._presentations = [
                new SideTrainUpgrade(),
                new ChestCollectPresentation(),
                new FreeSpinNoWinPause(),
                new FITH2BigWinPresentation(),
                new WinCapPresentation(),
                new FreespinOutroPresentation(),
            ];
    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this._presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }
}